import React, { useState } from 'react'

import routes from 'src/lib/rails-routes/rails-routes'
import { get } from 'lib/util'
import SearchPage from 'src/pages/SearchPage/SearchPage'

const SearchPageLazy = () => {
  const [results, setResults] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  const handleSearch = ({ key, target }) => {
    const { value } = target
    if (key === 'Enter') {
      setIsLoading(true)
      get(routes.advanced_search_show({ q: value })).then(({ data }) => {
        if (data.hasOwnProperty('location')) {
          window.location = data.location
        } else {
          setResults(data)
          setIsLoading(false)
        }
      })
    }
  }

  return (
    <SearchPage
      results={results}
      onSearch={handleSearch}
      isLoading={isLoading}
    />
  )
}

export default SearchPageLazy
